import {Component, Input} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {Vibration} from "@ionic-native/vibration";

@Component({
    selector: 'player',
    templateUrl: 'player.html'
})

export class Player {

    public config: any;

    public pulsed: boolean;
    public playscount: number;

    private audioSound: HTMLAudioElement;

    public tempoAtual: string = '0:00';
    public porceAtual: string = '0';

    @Input('playlist') private readonly playlist: any[];

    constructor(public util: Util, public vibration: Vibration) {

        this.config = CONFIG;

    }

    ngOnInit() {

        if (!this.playlist || !this.playlist.length) return;

        this.pulsed = false;
        this.playscount = 3;

        this.audioSound = new Audio(this.playlist[0]);
        this.audioSound.src = this.playlist[0].GaleriaFile;

        this.audioSound.addEventListener('timeupdate', () => {

            let sec: any;
            let min: any;

            sec = Math.floor( this.audioSound.currentTime );
            min = Math.floor( sec / 60 );
            min = (min >= 10 || !min) ? min : '0' + min;
            sec = Math.floor( sec % 60 );
            sec = sec >= 10 ? sec : '0' + sec;

            if(this.audioSound.currentTime) {
                this.tempoAtual = min + ":"+ sec;
                this.porceAtual = ((this.audioSound.currentTime / this.audioSound.duration) * 100).toString();
            }

        });

    }

    playMusica(musica?: any): void {

        if(musica && musica.GaleriaFile != this.audioSound.src) {

            this.audioSound.pause();
            this.audioSound.src = musica.GaleriaFile;
        }

        if (!this.audioSound.paused) {

            this.audioSound.pause();

        } else {

            this.audioSound.play();
        }

    }

    clickBarra(event) {

        let x = event.layerX;
        let w = event.target.offsetWidth;
        if(event.target.parentElement.className.indexOf('cursor-pointer') >= 0) {
            w = event.target.parentElement.offsetWidth;
        }

        this.audioSound.currentTime = (x / w) * this.audioSound.duration;

        if(!this.isPlaying()) {
            this.playMusica();
        }

    }

    isAtualMusica(musica) {

        return musica.GaleriaFile == this.audioSound.src && !this.audioSound.paused;

    }

    isPlaying() {

        return !this.audioSound.paused;

    }

    playsmore(press: boolean) {

        this.playscount += (!press ? 3 : this.playlist.length);
        if (press) this.util.impact();

    }

}



// WEBPACK FOOTER //
// ./src/components/player/player.ts